// Displays the music track currently playing

import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { useMedia } from '../../hooks';

const MusicDisplay: React.FC = () => {
  const {
    shouldShowMusicDisplay,
    musicTrackCurrent,
    musicTrackCurrentMetadata,
    currentVolumes,
    isMuted,
    loadImageFromUrl,
  } = useMedia();

  const albumImageUrl = musicTrackCurrentMetadata?.albumImageUrl;

  const onImageLoad = () => {
    if (albumImageUrl) {
      loadImageFromUrl(albumImageUrl);
    }
  };

  const hasTrackData = Boolean(
    musicTrackCurrent &&
    musicTrackCurrentMetadata &&
    currentVolumes.musicVolume > 0 &&
    !isMuted
  );

  return (
    <AnimatePresence>
      {shouldShowMusicDisplay && hasTrackData && (
        <motion.div
          key="music-display"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
          className="pointer-events-none fixed bottom-10 left-10 z-[1000] w-auto text-left"
        >
          <div className="min-w-100 rounded-2xl border bg-popover p-4 shadow-lg">
            <div className="flex gap-4">
              <div className="flex size-30 shrink-0 items-center justify-center overflow-hidden bg-muted">
                {albumImageUrl ? (
                  <img
                    src={albumImageUrl}
                    alt={musicTrackCurrentMetadata?.album || 'Album cover'}
                    onLoad={onImageLoad}
                    className="size-full object-cover"
                  />
                ) : (
                  <div className="flex size-full items-center justify-center text-2xl text-muted-foreground">
                    ♪
                  </div>
                )}
              </div>

              <div className="flex flex-1 flex-col justify-center text-left">
                <div className="mb-2 text-2xl font-bold text-primary">
                  {musicTrackCurrentMetadata?.title || 'Unknown Title'}
                </div>
                <div className="mb-1 text-base text-foreground">
                  {musicTrackCurrentMetadata?.artist || 'Unknown Artist'}
                </div>
                <div className="flex gap-1 text-base text-muted-foreground">
                  <span>
                    {musicTrackCurrentMetadata?.album || 'Unknown Album'}
                  </span>
                  {musicTrackCurrentMetadata?.year && (
                    <span>({musicTrackCurrentMetadata.year})</span>
                  )}
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default MusicDisplay;
